export const educationData = ["High School", "Intermediate", "Graduation"];
